export default {
  paginationCount: {
    id: 'bo_seller_global_paginated_table_pagination_count',
    defaultMessage: '{start} - {end} out of {count} items',
  },
}
